
export const MAIN = "/";
export const RESOURCES = "/resources";
export const PREZOS = "/prezos";
export const DOWNLOADS = "/downloads";
export const ABOUT = "/about";
